module.exports = __webpack_public_path__ + "static/img/unit-3.d92d036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/unit-3.png
// module id = HDcC
// module chunks = 51